import { render, staticRenderFns } from "./incidentReportCommutingIncident.vue?vue&type=template&id=1d72d1e4"
import script from "./incidentReportCommutingIncident.vue?vue&type=script&lang=js"
export * from "./incidentReportCommutingIncident.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports